import type { Components } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';

import type { Theme } from '../theme/types';

export const MuiTableHead = {
  styleOverrides: {
    root: {
      [`& .${tableCellClasses.root}`]: {
        backgroundColor: 'var(--mui-palette-background-level1)',
        color: 'var(--mui-palette-text-secondary)',
        lineHeight: 1,
      },
    },
  },
} satisfies Components<Theme>['MuiTableHead'];

export const MuiTableBody = {
  styleOverrides: {
    root: {
      [`& .${tableRowClasses.root}:last-child`]: {
        [`& .${tableCellClasses.root}`]: { '--TableCell-borderWidth': 0 },
      },
    },
  },
} satisfies Components<Theme>['MuiTableBody'];

export const MuiTableCell = {
  styleOverrides: {
    root: { borderBottom: 'var(--TableCell-borderWidth, 1px) solid var(--mui-palette-TableCell-border)' },
    paddingCheckbox: { padding: '0 0 0 24px' },
  },
} satisfies Components<Theme>['MuiTableCell'];

export const MuiTablePagination = {
  defaultProps: {
    slotProps: {
      select: { size: 'small', variant: 'outlined' },
    },
  },
  styleOverrides: {
    input: { marginRight: '16px', padding: 0 },
  },
} satisfies Components<Theme>['MuiTablePagination'];
